// as always be wary of float maths, this seems to work as required (for now)
// previous interations appended string zeros and regex replaced a decimal when detecting 4 digits.
export const fromFloyd = (floydPrice: string | number) => (Number(floydPrice) || 0) / 10000;

export const toFloyd = (price: number) => (Number(price) || 0).toFixed(4).replace('.', '');
